import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormSwitch } from 'redesign';
import { CompanySettingsData } from './settings-edit-page';

export const SettingsEdit = () => {
  const { control } = useFormContext<CompanySettingsData>();
  const { t } = useTranslation('ogp-screen-specific');
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <FormSwitch
        name="requiresEmployeeContract"
        control={control}
        label={t('settings-edit-page.employee-contract-requested-label')}
      />
      <FormSwitch
        name="requiresEmployeeCertificates"
        control={control}
        label={t('settings-edit-page.employee-certificates-requested-label')}
      />
    </Box>
  );
};
